import {
  GENERIC_SERVER_ERROR,
  REVOKE_MFA_VALIDATE_PASSWORD_ERROR,
  SETUP_MFA_ALREADY_REGISTERED_ERROR,
  SETUP_MFA_WEB_AUTHN_INVALID_REGISTRATION_ERROR,
  SETUP_MFA_WEB_AUTHN_LOCAL_LOGIN_REQUIRED_ERROR,
  SETUP_MFA_WEB_AUTHN_RECOVERY_OTP_REQUIRED_ERROR,
  SETUP_TOTP_INVALID_OTP,
} from '../constants/ui.labels'
import {
  GENERIC_SERVER_ERROR_CODE,
  MFA_INVALID_OTP,
  MFA_INVALID_REGISTRATION,
  MFA_LOCAL_LOGIN_REQUIRED,
  MFA_MECHANISM_ALREADY_REGISTERED,
  MFA_PASSWORD_DOESNT_MATCH,
  MFA_RECOVERY_OTP_REQUIRED,
} from '../constants/error.codes'

export default (errorCode, genericMessage) =>
  ({
    [MFA_LOCAL_LOGIN_REQUIRED]: SETUP_MFA_WEB_AUTHN_LOCAL_LOGIN_REQUIRED_ERROR,
    [MFA_RECOVERY_OTP_REQUIRED]:
      SETUP_MFA_WEB_AUTHN_RECOVERY_OTP_REQUIRED_ERROR,
    [MFA_MECHANISM_ALREADY_REGISTERED]: SETUP_MFA_ALREADY_REGISTERED_ERROR,
    [MFA_INVALID_REGISTRATION]: SETUP_MFA_WEB_AUTHN_INVALID_REGISTRATION_ERROR,
    [MFA_INVALID_OTP]: SETUP_TOTP_INVALID_OTP,
    [MFA_PASSWORD_DOESNT_MATCH]: REVOKE_MFA_VALIDATE_PASSWORD_ERROR,
    [GENERIC_SERVER_ERROR_CODE]: GENERIC_SERVER_ERROR,
  })[errorCode] || genericMessage
